import { Box, Typography } from '@mui/material';
import useIncentives from '../../../../api/hooks/useIncentives';
import Loading from '../../../../components/loading/Loading';
import IncentiveCatalog from '../../../homepage/components/incentives/IncentiveCatalog';
import ButtonLink from '../../../../components/buttonLink/ButtonLink';
import { useIntl } from 'react-intl';
import { useUserPrefs } from '../../../../context/UserPrefsProvider';
import { sampleSize } from 'lodash';

/**
 * Default incentives are always shown:
 * 9 - Electric Vehicle Rate Plans
 * 936 - Residential Charging Solutions Rebate
 *
 * Up to two preferred incentives are shown, they are selected randomly on each page load:
 * 128 - Vehicle Retirement Consumer Assistance Program
 * 135 - Clean Cars for All
 * 272 - Alternative Fuel Vehicle Refueling Property Credit
 * 332 - Driving Clean Assistance Program / Clean Cars 4 All
 * 360 - Ride and Drive Clean
 */
const DEFAULT_INCENTIVE_IDS = [9, 936]; // Always show
const PREFERRED_INCENTIVE_IDS = [128, 135, 272, 332, 360]; // Show to take up the rest of the space, up to 5.

const Incentives = () => {
  const { formatMessage } = useIntl();
  const { incentives, status } = useIncentives();
  const { setUserPrefs } = useUserPrefs();

  const allIncentives = incentives?.allIncentives || [];

  const defaultIncentives = allIncentives.filter((incentive) =>
    DEFAULT_INCENTIVE_IDS.includes(incentive.zrId),
  );
  const preferredIncentives = allIncentives.filter((incentive) =>
    PREFERRED_INCENTIVE_IDS.includes(incentive.zrId),
  );
  const incentivesForUsedVehicles = [...defaultIncentives, ...sampleSize(preferredIncentives, 2)];

  return (
    <Box>
      <Box textAlign="center">
        <Typography variant="h2" mb="0.5rem">
          {formatMessage({ id: 'incomeQualified.incentives.headline' })}
        </Typography>
        <Typography whiteSpace="pre-line" fontSize="1.25rem" fontWeight="300" mb="1rem">
          {formatMessage({ id: 'incomeQualified.incentives.details' })}
        </Typography>
      </Box>
      {status === 'loading' && <Loading />}
      {status === 'idle' && incentivesForUsedVehicles && (
        <IncentiveCatalog incentives={incentivesForUsedVehicles} />
      )}
      <Box textAlign="center">
        <ButtonLink
          action="qualified-income-incentives"
          to="/incentives"
          onClick={() => {
            setUserPrefs({
              householdIncome: 50000,
              householdSize: 4,
              taxFilingStatus: 'head_of_household',
              zipcode: '95110',
            });
          }}
        >
          {formatMessage({ id: 'incomeQualified.incentives.personalizeButton' })}
        </ButtonLink>
      </Box>
    </Box>
  );
};

export default Incentives;
